<template>
  <footer class="app-footer mt-5">
    <div class="footer-yellow-bar"></div>
    <b-container>
      <b-row class="py-4">
        <b-col cols="12" md="5" class="mb-3 mb-md-0">
          <h6 class="footer-title mb-2">GUC Voile</h6>
            <p class="footer-text">
              © {{ currentYear }} GUC Voile. 
              <br> <small>par <a href="mailto:leo@guc-voile.com" class="footer-link">Léo Marty</a></small>
            </p>
            <a href="https://maps.app.goo.gl/c49QM4uz1JNKW1gs8" target="_blank" class="footer-link footer-address">
              <b-icon icon="geo-alt-fill" class="mr-1"></b-icon>
              Aux Combettes<br>
              38650 Treffort
            </a>
        </b-col>

        <b-col cols="12" md="3" class="mb-3 mb-md-0">
          <h6 class="footer-title mb-2">Navigation</h6>
          <ul class="list-unstyled mb-0">
            <li class="mb-1">
              <router-link to="/" class="footer-link">Accueil</router-link>
            </li>
            <li class="mb-1">
              <router-link to="/mes-inscriptions" class="footer-link">Mes inscriptions</router-link>
            </li>
            <li>
              <router-link to="/mes-covoiturages" class="footer-link">Mes covoiturages</router-link>
            </li>

          </ul>
        </b-col>

        <b-col cols="12" md="2" class="mb-3 mb-md-0">
          <h6 class="footer-title mb-2">Informations</h6>
          <ul class="list-unstyled mb-0">
            <li class="mb-1">
              <a class="footer-link" href="https://www.guc-voile.com/infos-pratiques" target="_blank">Contact</a>
            </li>
                        <li class="mb-1">
              <a class="footer-link" href="https://www.helloasso.com/associations/guc-voile/formulaires/1" target="_blank">Dons</a>
            </li>
          </ul>
        </b-col>

        <b-col cols="12" md="2">
          <h6 class="footer-title mb-2">Réseaux</h6>
          <div class="social-icons">
            <a href="https://www.instagram.com/gucvoile" target="_blank" class="social-icon" aria-label="Instagram">
              <b-icon icon="instagram"></b-icon>
            </a>
            <a href="https://www.facebook.com/GucVoile" target="_blank" class="social-icon" aria-label="Facebook">
              <b-icon icon="facebook"></b-icon>
            </a>
            <a href="https://www.strava.com/clubs/gucvoile" target="_blank" class="social-icon" aria-label="Strava">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em">
                <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169"/>
              </svg>
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>
<script>
export default {
  name: 'app-footer',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>
<style scoped>
.app-footer {
  background: var(--gradient-footer);
}

.footer-yellow-bar {
  height: 30px;
  background-color: var(--color-guc-yellow);
}

.footer-title {
  font-weight: 700;
  color: var(--color-text-on-dark);
}

.footer-text {
  color: var(--color-text-muted-on-dark);
  font-size: 0.95rem;
}

.footer-link {
  color: var(--color-text-on-dark);
  text-decoration: none;
  opacity: 0.9;
}

.footer-address {
  font-size: 0.95rem;
  line-height: 1.6;
}

.footer-link:hover {
  color: var(--color-text-on-dark);
  opacity: 1;
  text-decoration: underline;
}

.social-icons {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.social-icon {
  color: var(--color-text-on-dark);
  font-size: 1.25rem;
  opacity: 0.9;
  transition: opacity 0.2s, transform 0.2s;
  line-height: 1;
}

.social-icon:hover {
  opacity: 1;
  transform: translateY(-2px);
}
</style>
